import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useModal } from '../../../components/contract-item/useModal';
import { Col, Card, Container, Row } from 'shards-react';
import Table from '../../../components/UI/Table/Table';
import PageTitle from '../../../components/common/PageTitle';
export function EstablishmentContracts({ establishmentId }) {
  const { t } = useTranslation();
  const displayOptions = { addButton: true, editAction: true, deleteAction: true };
  const { attributes, actions, getContractsByEstablishmentId, getEstablishmentById } = useModal({
    addButton: true,
    editAction: true,
    deleteAction: true,
  });
  const [establishment, setEstablishment] = React.useState(null);
  const [query, setQuery] = React.useState({ page: null, order: 'status DESC', keyword: '', limit: 10, establishmentId });
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const getData = () => {
    setLoading(true);
    getContractsByEstablishmentId(establishmentId, query)
      .then((res) => {
        setData({
          listContract: res.data.items,
          totalPages: res.data.totalPages,
          totalItems: res.data.totalItems,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error({ error });
        Swal.fire(t('contract.ERROR_GET_CONTRACTS'), '', 'error');
        setLoading(false);
      });
  };
  const getEstablishmentData = () => {
    getEstablishmentById(establishmentId).then((res) => {
      setEstablishment(res.data);
    });
  };

  React.useEffect(() => {
    getEstablishmentData();
  }, [establishmentId]);
  React.useEffect(() => {
    getData();
  }, [query, establishmentId]);
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title={t('contract.title.list')}
          subtitle={establishment?.name + ' '+establishment?.region+' - ' + t('contract.subTitle')}
          className="text-sm-left"
        />
      </Row>
      <Row noGutters className="page-header pt-0 pb-4">
        <Col xs="12" sm="4">
          <span className="text-uppercase page-subtitle">Email</span>
          <h3 className="page-title" style={{ fontSize: '1rem' }}>
            {establishment?.email}
          </h3>
        </Col>
        <Col xs="12" sm="4">
          <span className="text-uppercase page-subtitle">Numero de téléphone</span>
          <h3 className="page-title" style={{ fontSize: '1rem' }}>
            {establishment?.phone}
          </h3>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card small className="mb-4">
            <Table
              attributes={attributes}
              actions={actions}
              data={data?.listContract}
              loading={loading}
              search={getContractsByEstablishmentId}
              numberOfPage={data?.totalPages}
              query={query}
              setQuery={setQuery}
              textButton={displayOptions.addButton && t('contract.add')}
              linkButton={displayOptions.addButton && '/contract/add'}
              pdfTitle={`${t(establishment?.category)} ${establishment?.name} - Liste des contrats`}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
